export default {
  history: 'História',
  version: 'Verzia',
};
